<template>
  <div class="actions-list">
    <div v-for="item in actionItems" :key="item.key" class="actions-list__row">
      <div class="font-weight-medium">{{ item.label }}</div>
      <v-btn-toggle
        v-model="docTypeCredentials[item.key]"
        mandatory
        rounded="lg"
        variant="outlined"
        density="comfortable">
        <v-btn v-tooltip="'Не вказано'" :value="null" icon="mdi-cancel"></v-btn>
        <v-btn
          v-tooltip="'Так'"
          color="success"
          :value="true"
          icon="mdi-check"></v-btn>
        <v-btn
          v-tooltip="'Ні'"
          color="error"
          :value="false"
          icon="mdi-close"></v-btn>
      </v-btn-toggle>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useDocType } from '../docType'
import { DocumentTypeDefinitionCredentials } from '@/utils/types/documentType'

defineOptions({
  name: 'Actions',
})

type ActionFieldKey = Extract<
  keyof DocumentTypeDefinitionCredentials,
  | 'isApprovalRequired'
  | 'isSigningRequired'
  | 'isApprovalEcpRequired'
  | 'isSigningEcpRequired'
>

const actionItems: { key: ActionFieldKey; label: string }[] = [
  {
    key: 'isApprovalEcpRequired',
    label: 'Використовувати ЕЦП при візуванні',
  },
  {
    key: 'isSigningEcpRequired',
    label: 'Використовувати ЕЦП при підписанні',
  },
  {
    key: 'isSigningRequired',
    label: 'Підписання проекту документа є обов’язковим',
  },
  {
    key: 'isApprovalRequired',
    label: 'Погодження проекту документа є обов’язковим',
  },
]

const { docTypeCredentials } = useDocType()
</script>

<style lang="scss" scoped>
.actions-list {
  overflow: hidden;
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: 12px;

  &__row {
    min-height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 24px;

    &:not(:last-child) {
      border-bottom: 1px solid
        rgba(var(--v-border-color), var(--v-border-opacity));
    }
  }
}
</style>
